import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { useNavigate } from 'react-router';

const BackButton = () => {
  const navigate = useNavigate();

  const back = () => {
    navigate('/');
  };

  return (
    <IconButton style={{marginRight: 24}}  aria-label="back" onClick={back}>
      <KeyboardBackspaceRoundedIcon />
    </IconButton>
  );
};

export default BackButton;
